export const getStartOfDay = () => {
  const now = new Date(); // Get the current date and time
  now.setHours(0, 0, 0, 0); // Set the time to midnight (00:00:00.000)
  return now;
};
